/*---------------------------
  投稿内のタグにクラスを付ける
---------------------------*/
$(function(){
  $('.single__inner a').addClass('single-parts__link');
  $('.single__inner h2').addClass('single-parts__ttl');
  $('.single__inner h3').addClass('single-parts__sttl');
  $('.single__inner h4').addClass('single-parts__ssttl');
  $('.single__inner h5').addClass('single-parts__sssttl');
  $('.single__inner p').addClass('single-parts__txt');
  $('.single__inner ul').addClass('single-parts__list');
  $('.single__inner ol').addClass('single-parts__numlist');
  $('.single__inner table').addClass('single-parts__tbl');
  $('.single__inner table tr').addClass('single-parts__tr');
  $('.single__inner table tr td').addClass('single-parts__td');
});
